module.exports = __webpack_public_path__ + "static/img/car7.4a87e22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car7.png
// module id = cRQK
// module chunks = 1